import React, { useEffect } from 'react'
import { Button, Flex, Select } from 'antd'
import { useStore } from 'effector-react'
import {
  $generateBalanceFilter,
  $paymentSystems,
  paymentSystemsMounted,
} from '../generalBalanceFilter/model'
import { setActiveBalanceFilter } from './model'
import { useUrlFilters } from '../../../../../libs/useUrlFilters'
import { countries } from 'src/libs/countries'

const FILTER_CONFIG = {
  paymentSystem: { type: 'string' as const },
  activeBalanceCountries: { type: 'array' as const },
}

export const ActiveBalanceFilter: React.FC = () => {
  const generateBalanceFilter = useStore($generateBalanceFilter)
  const { filters, setFilter, setFilters } = useUrlFilters(FILTER_CONFIG)

  const paymentSystemOptions = useStore($paymentSystems).map(
    (paymentSystem) => ({
      value: String(paymentSystem.id),
      label: paymentSystem.name,
    }),
  )

  useEffect(() => {
    paymentSystemsMounted()
  }, [])

  const handleResetFilters = () => {
    if (
      filters.paymentSystem ||
      (filters.activeBalanceCountries ?? []).length
    ) {
      setFilters({
        paymentSystem: undefined,
        activeBalanceCountries: undefined,
      })
      setActiveBalanceFilter({
        activeBalanceCountries: [],
        paymentSystem: '',
      })
    }
  }

  useEffect(() => {
    if (
      !generateBalanceFilter.date.dateFrom &&
      !generateBalanceFilter.date.dateTo
    ) {
      return
    }
    setFilter('activeBalanceCountries', generateBalanceFilter.countries)
    setActiveBalanceFilter({
      paymentSystem: filters.paymentSystem ?? '',
      activeBalanceCountries: generateBalanceFilter.countries,
    })
  }, [generateBalanceFilter])

  return (
    <Flex gap={16} wrap style={{ width: '75%', height: 'auto' }}>
      <Select
        size="large"
        style={{ flex: '1 1 140px', minWidth: 0 }}
        placeholder="Payment system"
        value={filters.paymentSystem || undefined}
        showSearch
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '')
            .toString()
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        options={[
          { value: '', label: 'Payment system' },
          ...paymentSystemOptions,
        ]}
        onChange={(value: string) => {
          setFilter('paymentSystem', value)
          setActiveBalanceFilter({
            paymentSystem: value,
            activeBalanceCountries: filters.activeBalanceCountries ?? [],
          })
        }}
      />
      <Select
        mode="multiple"
        size="large"
        style={{ flex: '1 1 140px', minWidth: 0 }}
        placeholder="Countries"
        maxTagCount="responsive"
        value={filters.activeBalanceCountries ?? []}
        options={generateBalanceFilter.countries.map((countryCode) => ({
          value: countryCode,
          label:
            countries.find((country) => country.value === countryCode)?.text ||
            countryCode,
        }))}
        onChange={(values: string[]) => {
          setFilter('activeBalanceCountries', values)
          setActiveBalanceFilter({
            paymentSystem: filters.paymentSystem ?? '',
            activeBalanceCountries: values,
          })
        }}
      />
      <Button
        style={{ flex: '1 1 120px', minWidth: 0 }}
        size="large"
        color="primary"
        variant="solid"
        onClick={handleResetFilters}
      >
        Reset filters
      </Button>
    </Flex>
  )
}
